import React, { Component } from 'react';
import VerticalLayout from "../../../components/VerticalLayout/";
import VehicleDetailPage from './VehicleDetailPage';

class VehicleDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
           
        }        
    }

    componentDidCatch(){
        
        localStorage.getItem("authUser")?this.props.history.push('/vehicles'):this.props.history.push('/404')
    }


    render() {
        
        let obj = JSON.parse(localStorage.getItem("authUser"))

        return (
                obj?
                <VerticalLayout>
                    <VehicleDetailPage 
                    id = {this.props.match.params.id}
                    history = {this.props.history}
                    obj = {obj}
                    />

                </VerticalLayout>

                :

                <VehicleDetailPage 
                    id = {this.props.match.params.id}
                    history = {this.props.history}
                    obj = {obj}
                />
          
        );
    }
}

export default VehicleDetail;
